module.exports = __webpack_public_path__ + "img/potion_img_04.d41a1da2.png";